import { mergeModels, useModel, ref, computed, watch, resolveComponent, createElementBlock, openBlock, renderSlot, createVNode, mergeProps, withCtx, createBlock, createCommentVNode, unref, isRef, createElementVNode, Fragment, renderList, normalizeClass } from "vue";
import "../../graphql/queries.js";
import "../../graphql/subscriptions.js";
import "../../plugins/apollo.js";
import "lodash-es";
import "moment";
import { uuid } from "../../utils/uuid.js";
import "../../constants/UserPolicy.js";
import "pinia";
import "../../store/index.js";
import { useBanza } from "../../plugins/banza/global.js";
import "axios";
import "vue-router";
import "../../plugins/i18n.js";
import "maska";
import "vuetify";
import "vue-social-sharing";
import "@duannx/vue-client-only";
import "vuetify/components/VSnackbar";
import "../../assets/3448554beb4b633a.svg";
import "../../assets/e94e4817134d7c25.png";
import "../../assets/5341da3ffbec0137.png";
import "../../assets/01f50022317dccd7.png";
import "vuetify/components/VImg";
import "../../constants/components/index.js";
import "../../graphql/system-settings.js";
import "../../graphql/session-store.js";
import "vee-validate";
import "../../composables/useModalPage.js";
import "tiny-emitter/instance";
import { usePortalIcons } from "../../plugins/banza/icons.js";
import "../../graphql/mutations.js";
import "graphql-tag";
import "../../graphql/entity.js";
import "../../graphql/lookups.js";
/* empty css                         */
import { VDialog } from "vuetify/components/VDialog";
import "sweetalert2";
import "@vee-validate/i18n";
/* empty css                        */
import { VCard } from "vuetify/components/VCard";
import "vuetify/components/VOverlay";
import "vuetify/components/VProgressCircular";
/* empty css                                  */
import "vuetify/components/VDivider";
import "vuetify/components/VList";
import EmptyData from "../Base/EmptyData.vue.js";
import "../../graphql/navigation-menu.js";
import "vuetify/components/VSkeletonLoader";
/* empty css                                 */
import { VBtn } from "vuetify/components/VBtn";
import "vuetify/components/VNavigationDrawer";
import "vuetify/components/VMenu";
import "../Auth/AppleAuthButton/AppleAuthButton.js";
import "../Auth/FacebookAuthButton/FacebookAuthButton.js";
import "../Auth/GoogleAuthButton/GoogleAuthButton.js";
import "../Auth/InstagramAuthButton/InstagramAuthButton.js";
import "../Auth/TelegramAuthButton/TelegramAuthButton.js";
/* empty css                               */
import "vuetify/components/VGrid";
import "../Base/index.js";
import "vuex";
/* empty css                        */
import "vuetify/components/VIcon";
import "vuetify/components/VProgressLinear";
import "vuetify/components/transitions";
import { RecycleScroller } from "vue-virtual-scroller";
import "vue-virtual-scroller/dist/vue-virtual-scroller.css";
import mdi from "../../icons/mdi/index.js";
/* empty css                     */
import { VBtnToggle } from "vuetify/components/VBtnToggle";
import "../../assets/6f5dc1ff0a697731.svg";
import "../../assets/888bb8db73be3c15.svg";
/* empty css                             */
import "vuetify/components/VInfiniteScroll";
/* empty css                                  */
/* empty css                      */
import "vuetify/components/VChip";
/* empty css                          */
import "../HtmlEditor/index.js";
import "../Messages/vue-advanced-chat/lib/RoomsList/RoomContent/RoomContent.vue.js";
import "../Messages/vue-advanced-chat/lib/Room/Room.vue.js";
/* empty css                                               */
/* empty css                        */
import "../News/NewsModule/NewsModule.vue.js";
import "../News/NewsModule/NewsList.vue.js";
import "../../graphql/news.js";
/* empty css                        */
import "../Pages/index.js";
import "vue3-runtime-template";
import "ckeditor5/ckeditor5.css";
/* empty css                                 */
import "vuetify/components/VWindow";
import "../../assets/5a0af7dd23957928.png";
/* empty css                             */
/* empty css                                    */
import "vuetify/components/VHover";
import "../../constants/NewsGroup.js";
/* empty css                                     */
import "vuetify/components/VTabs";
import "vuetify/directives";
import "@iconify/vue";
import "mobile-device-detect";
/* empty css                                   */
import "vuetify/components/VBottomSheet";
import "../../graphql/favorites.js";
import "../../plugins/tracker/page-tracker.js";
/* empty css                             */
import "../../graphql/notifications.js";
/* empty css                                  */
import "../../constants/CommunicationChannels.js";
/* empty css                            */
import "vuetify/components/VColorPicker";
/* empty css                                                */
import "vuetify/components/VTextarea";
/* empty css                                             */
/* empty css                          */
/* empty css                       */
import "vuetify/components";
/* empty css                             */
/* empty css                     */
import "../../graphql/system-events.js";
/* empty css                                        */
/* empty css                         */
import "vuetify/components/VTooltip";
/* empty css                         */
import "vuetify/components/VCombobox";
import "vuetify/components/VExpansionPanel";
import "vuetify/components/VTable";
import "../../graphql/files.js";
/* empty css                            */
import "vuetify/components/VForm";
/* empty css                                 */
/* empty css                                               */
import "vuetify/components/VAlert";
/* empty css                                    */
import "vue-dndrop";
/* empty css                                            */
/* empty css                                    */
import "vue-advanced-cropper";
import "vue-advanced-cropper/dist/style.css";
/* empty css                        */
import "vuetify/components/VFileInput";
/* empty css                            */
import "vuetify/components/VAvatar";
/* empty css                                  */
import "vuetify/components/VTextField";
import "vuetify/components/VTimeline";
/* empty css                              */
import "../../graphql/public-articles.js";
/* empty css                                           */
/* empty css                               */
import "vuetify/components/VChipGroup";
import "vuetify/components/VSelect";
import "vuetify/components/VSheet";
/* empty css                                  */
import "vuetify/components/VItemGroup";
/* empty css                             */
import "vuetify/components/VCheckbox";
import "vuetify/components/VRadio";
import "vuetify/components/VRadioGroup";
import "cronstrue/i18n";
import "cron-parser";
/* empty css                        */
import "../../graphql/quartz.js";
import "vue-i18n";
import "../../graphql/integration-systems.js";
import "../../constants/IntegrationSystemLogDirection.js";
/* empty css                                                      */
/* empty css                                    */
const _hoisted_1 = { class: "d-inline-flex align-center g-2" };
const _hoisted_2 = { class: "d-flex flex-nowrap align-center ga-4" };
const _hoisted_3 = { class: "d-flex justify-center" };
const _hoisted_4 = {
  key: 0,
  class: "d-flex justify-center"
};
const _hoisted_5 = ["onClick"];
const _sfc_main = {
  __name: "BanzaIconPicker",
  props: /* @__PURE__ */ mergeModels({
    size: {
      type: Number,
      default: 24
    },
    clearable: {
      type: Boolean,
      default: false
    }
  }, {
    "modelValue": {},
    "modelModifiers": {}
  }),
  emits: ["update:modelValue"],
  setup(__props) {
    const banza = useBanza();
    const portalIcons = usePortalIcons();
    const value = useModel(__props, "modelValue");
    const showMenu = ref(false);
    const iconSets = ref([...portalIcons, mdi]);
    const search = ref("");
    const selectedSet = ref("");
    const selectedType = ref("");
    const selectedSetConfig = computed(() => {
      return iconSets.value.find((s) => s.prefix === selectedSet.value);
    });
    const selectedSetTypes = computed(() => {
      var _a;
      return ((_a = selectedSetConfig.value) == null ? void 0 : _a.types) || [];
    });
    const selectedSetIcons = computed(() => {
      if (!selectedSetConfig.value) {
        return [];
      }
      const icons = selectedSetConfig.value.getArray(selectedType.value) || [];
      const iconsSearched = search.value ? icons.filter(
        (i) => i.toLowerCase().includes(search.value.toLowerCase())
      ) : icons;
      return iconsSearched.map((i) => ({
        id: uuid(),
        icon: i
      }));
    });
    const selectIcon = (icon) => {
      value.value = icon;
      banza.copyTextToClipboard(icon);
      close();
    };
    const selectIconFromSearch = () => {
      if (search.value) {
        selectIcon(search.value);
      }
    };
    const clear = () => {
      value.value = null;
    };
    const reset = () => {
      var _a, _b, _c;
      search.value = value.value ?? "";
      const set = value.value ? iconSets.value.find((s) => s.isIconFromSet(value.value)) : null;
      selectedSet.value = (set == null ? void 0 : set.prefix) || ((_a = iconSets.value[0]) == null ? void 0 : _a.prefix);
      selectedType.value = ((_b = set == null ? void 0 : set.types) == null ? void 0 : _b.length) > 0 && set.types.find((t) => {
        var _a2, _b2;
        return (_b2 = (_a2 = set.getArray) == null ? void 0 : _a2.call(set, t)) == null ? void 0 : _b2.includes(value.value);
      }) || ((_c = selectedSetTypes.value) == null ? void 0 : _c[0]);
    };
    const open = () => {
      showMenu.value = true;
    };
    const close = () => {
      showMenu.value = false;
    };
    watch(
      showMenu,
      (show) => {
        if (show) {
          reset();
        }
      },
      {
        immediate: true
      }
    );
    watch(selectedSet, (set) => {
      var _a;
      if (set) {
        selectedType.value = ((_a = selectedSetTypes.value) == null ? void 0 : _a[0]) || "";
      }
    });
    let resizeObserver = null;
    const scroller = ref(null);
    const itemSize = ref(64);
    const itemsPerRow = ref(5);
    const updateGrid = () => {
      if (scroller.value) {
        const width = scroller.value.clientWidth;
        itemsPerRow.value = Math.min(Math.max(1, Math.floor(width / 64)), 8);
        itemSize.value = width / itemsPerRow.value;
      }
    };
    const onGridMounted = () => {
      if (scroller.value) {
        resizeObserver = new ResizeObserver(updateGrid);
        resizeObserver.observe(scroller.value);
        updateGrid();
      }
    };
    const onGridUnmounted = () => {
      if (resizeObserver && scroller.value) {
        resizeObserver.unobserve(scroller.value);
        resizeObserver.disconnect();
      }
    };
    return (_ctx, _cache) => {
      const _component_b_icon = resolveComponent("b-icon");
      const _component_b_btn = resolveComponent("b-btn");
      const _component_b_text_edit = resolveComponent("b-text-edit");
      return openBlock(), createElementBlock("div", _hoisted_1, [
        renderSlot(_ctx.$slots, "activator", {
          value: value.value,
          open,
          close
        }, () => [
          createVNode(_component_b_btn, mergeProps({ variant: "outlined" }, _ctx.$attrs, { onClick: open }), {
            default: withCtx(() => [
              createVNode(_component_b_icon, {
                icon: value.value,
                size: __props.size
              }, null, 8, ["icon", "size"]),
              renderSlot(_ctx.$slots, "label")
            ]),
            _: 3
          }, 16)
        ]),
        renderSlot(_ctx.$slots, "clear", {}, () => [
          __props.clearable && value.value ? (openBlock(), createBlock(_component_b_icon, {
            key: 0,
            icon: "lets-icons:close-ring-duotone",
            color: "primary",
            size: __props.size,
            onClick: clear
          }, null, 8, ["size"])) : createCommentVNode("", true)
        ]),
        createVNode(VDialog, {
          modelValue: unref(showMenu),
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => isRef(showMenu) ? showMenu.value = $event : null),
          "min-height": "280px",
          height: "600px",
          "min-width": "240px",
          width: "560px",
          scrollable: ""
        }, {
          default: withCtx(() => [
            createVNode(VCard, { class: "rounded-xl pa-6 ga-2" }, {
              default: withCtx(() => [
                createElementVNode("div", _hoisted_2, [
                  unref(search) || value.value ? (openBlock(), createBlock(_component_b_icon, {
                    key: 0,
                    icon: unref(search) || value.value,
                    size: 40
                  }, null, 8, ["icon"])) : createCommentVNode("", true),
                  createVNode(_component_b_text_edit, {
                    modelValue: unref(search),
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => isRef(search) ? search.value = $event : null),
                    placeholder: _ctx.$t("base.labels.icon_picker_placeholder"),
                    clearable: true,
                    "append-icon": unref(search) ? "mdi-check" : null,
                    "onClick:append": selectIconFromSearch
                  }, null, 8, ["modelValue", "placeholder", "append-icon"])
                ]),
                _cache[4] || (_cache[4] = createElementVNode("div", { class: "d-flex flex-nowrap align-center ga-4 ml-auto" }, [
                  createElementVNode("a", {
                    class: "text-primary",
                    href: "https://pictogrammers.github.io/@mdi/font/6.5.95/",
                    target: "_blank"
                  }, "Mdi icons"),
                  createElementVNode("a", {
                    class: "text-primary",
                    href: "https://icon-sets.iconify.design/",
                    target: "_blank"
                  }, "Iconify sets")
                ], -1)),
                createElementVNode("div", _hoisted_3, [
                  createVNode(VBtnToggle, {
                    class: "w-100 rounded-lg overflow-auto",
                    modelValue: unref(selectedSet),
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => isRef(selectedSet) ? selectedSet.value = $event : null),
                    density: "compact",
                    divided: "",
                    variant: "outlined",
                    mandatory: ""
                  }, {
                    default: withCtx(() => [
                      (openBlock(true), createElementBlock(Fragment, null, renderList(unref(iconSets), (set, i) => {
                        return openBlock(), createBlock(VBtn, {
                          class: "flex-grow-1",
                          key: i,
                          value: set.prefix,
                          text: set.name,
                          size: "small"
                        }, null, 8, ["value", "text"]);
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]),
                unref(selectedSetTypes).length > 1 ? (openBlock(), createElementBlock("div", _hoisted_4, [
                  createVNode(VBtnToggle, {
                    class: "w-100 rounded-lg overflow-auto",
                    modelValue: unref(selectedType),
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => isRef(selectedType) ? selectedType.value = $event : null),
                    density: "compact",
                    divided: "",
                    variant: "outlined",
                    mandatory: ""
                  }, {
                    default: withCtx(() => [
                      (openBlock(true), createElementBlock(Fragment, null, renderList(unref(selectedSetTypes), (type, i) => {
                        return openBlock(), createBlock(VBtn, {
                          class: "flex-grow-1",
                          key: i,
                          value: type,
                          text: type,
                          size: "small"
                        }, null, 8, ["value", "text"]);
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ])) : createCommentVNode("", true),
                createElementVNode("div", {
                  ref_key: "scroller",
                  ref: scroller,
                  class: "b-icons__scroller"
                }, [
                  createVNode(unref(RecycleScroller), {
                    class: normalizeClass("b-icons__grid hide-scrollbar"),
                    items: unref(selectedSetIcons),
                    "item-size": 64,
                    "item-secondary-size": unref(itemSize),
                    "grid-items": unref(itemsPerRow),
                    onVnodeMounted: onGridMounted,
                    onVnodeUnmounted: onGridUnmounted
                  }, {
                    default: withCtx(({ item }) => [
                      createElementVNode("div", {
                        class: "b-icons__item",
                        onClick: ($event) => selectIcon(item.icon)
                      }, [
                        createVNode(_component_b_icon, {
                          icon: item.icon,
                          size: 40
                        }, null, 8, ["icon"])
                      ], 8, _hoisted_5)
                    ]),
                    _: 1
                  }, 8, ["items", "item-secondary-size", "grid-items"])
                ], 512),
                !unref(selectedSetIcons).length ? (openBlock(), createBlock(unref(EmptyData), {
                  key: 1,
                  class: "pa-6",
                  title: _ctx.$t("base.labels.table_no_data"),
                  width: 120
                }, null, 8, ["title"])) : createCommentVNode("", true)
              ]),
              _: 1,
              __: [4]
            })
          ]),
          _: 1
        }, 8, ["modelValue"])
      ]);
    };
  }
};
export {
  _sfc_main as default
};
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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
